<!-- 教育局-退费管理 -->
<template>
  <div>
    <div class="index">
      <div class="title">
        <div class="span1">
          <span>{{ $route.name }}</span>
        </div>
      </div>

      <div>
        <el-form :inline="true" :model="queryParams">
          <el-form-item label="订单编号">
            <el-input
              v-model="queryParams.orderNo"
              placeholder="请输入"
              style="width: 200px"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="退单编号">
            <el-input
              v-model="queryParams.refundNo"
              placeholder="请输入"
              style="width: 200px"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="课程名称">
            <el-input
              v-model="queryParams.cname"
              placeholder="请输入"
              style="width: 200px"
              clearable
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="提供方">
            <el-input placeholder="请输入" v-model="queryParams.orgName" clearable></el-input>
          </el-form-item> -->
          <el-form-item label="退款时间">
            <el-date-picker
              v-model="queryParams.date"
              type="daterange"
              style="width: 280px"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="" style="margin-left: 20px">
            <el-button type="primary" size="small" @click="searchFun()"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
        <!-- <div class="Homeboxtop_nav_tab">
          <span
            v-for="(item, index) in tabList"
            :class="['res-tab', { active: item.name === tabName }]"
            :key="index"
            @click="tabClick(item)"
          >
            {{ item.name }}
          </span>
        </div> -->

        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              prop="refundNo"
              label="退款单号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="orderNo"
              label="订单编号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="cname"
              label="课程名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="orgName"
              label="所属单位"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="buyerName"
              label="购买用户"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="refundSuccessTime"
              label="退款时间"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                {{  dayjs(scope.row.refundSuccessTime).format("YYYY.MM.DD HH:mm")}}
              </template>
            </el-table-column>
            <el-table-column
              prop="amountPayerRefund"
              label="退款金额"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.amountPayerRefund/100 || 0 }}
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/education/index.js";
import dayjs from "dayjs";
export default {
  components: {},
  data() {
    return {
      queryParams: {
        orgName: "",
        cname: "",
        refundNo: "",
        orderNo: "",
        date: "",
      },
      pageNum: 1,
      pageSize: 10,
      totalPage: 0,
      tabList: [{ name: "未退费" }, { name: "已退费" }, { name: "已拒绝" }],
      tableData: [],
      tabName: "未退费",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  watch: {
    tabName: function (n, o) {
      this.getDataList();
    },
  },
  created() {
    this.getDataList();
    if (
      sessionStorage.getItem("user_level") === "99" ||
      ["1", "10"].indexOf(sessionStorage.getItem("user_level")) > -1
    ) {
      this.tableData = [
      ];
    }
  },
  methods: {
    dayjs,
    async getDataList() {
      let _this = this.queryParams;
      let startTime = "",
        endTime = "";
      if (_this.date) {
        startTime = dayjs(_this.date[0]).format("YYYY-MM-DD");
        endTime = dayjs(_this.date[1]).format("YYYY-MM-DD");
      }
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        startTime: startTime,
        endTime: endTime,
        orgName: _this.orgName,
        cname: _this.cname,
        refundNo: _this.refundNo,
        orderNo: _this.orderNo,
      };
      for(var key in params){
        if(params[key]==''){
           delete params[key]
        }
      }
      let { result, data } = await api.handleRefundsList(params);
      if (result === "000000") {
        this.tableData = data.list;
        this.totalPage=data.total
      }
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    tabClick(item) {
      this.tabName = item.name;
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 150px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}

.Homeboxtop_nav_tab {
  span {
    padding-bottom: 15px;
  }
}
</style>
